/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentVerificationResponseItem } from '../../models/document-verification-response-item';

export interface VerifyDocuments$Params {
      body: Array<string>
}

export function verifyDocuments(http: HttpClient, rootUrl: string, params: VerifyDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentVerificationResponseItem>>> {
  const rb = new RequestBuilder(rootUrl, verifyDocuments.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DocumentVerificationResponseItem>>;
    })
  );
}

verifyDocuments.PATH = '/documents/verify';
